import { api, unwrap } from './client';

/**
 * Reference data API — countries and currencies.
 * Data is served from the backend (no DB, hardcoded lookup tables).
 */

export async function getCountries() {
  const res = await api.get('/reference/countries');
  return unwrap(res) || [];
}

export async function getCurrencies() {
  const res = await api.get('/reference/currencies');
  return unwrap(res) || [];
}
